export default __webpack_public_path__ + "static/Natural_Light_Indoor_1600kbps-7723c3030e4cd4852de5789a8f27dfa0.avif";